import { render, staticRenderFns } from "./SidebarDropdown.vue?vue&type=template&id=21f1fe3f&"
import script from "./SidebarDropdown.vue?vue&type=script&lang=js&"
export * from "./SidebarDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports